<template>
  <div>
    <!-- <am-pm-data/> -->
    <do-leave />
  </div>
</template>

<script>
// import amPmData from "@/views/leave/components/AmPmData.vue"
// import DoLeave from "@/views/leave/children/DoLeave";
import DoLeave from "@/views/leave/LeaveInfo";

export default {
  components: {
    // amPmData,
    DoLeave,
  },
};
</script>

<style>
</style>